import React from 'react';

import restrictions from './config.json'

import {getFormatFunction} from "./format"
import Chart from "./Chart";

import {
    getTimeToConversion,
    getBuysByDate,
    getMeasurementsByDate,
    getUniqueLoginStatistics,
    getSampleStatistics
} from "./fetch";

export default class Statistics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            chartType: "line",
            alternative: "TimeToConversion",
            company: "All",
            interval: "day",
            period: "month",
            cohort: "day",
            restrictions: restrictions,
            representation: "discrete",
            exclude: "include",
            option: "Sweden"
        };

        this.menus = [
            "TimeToConversion", "BuysByDate", "MeasurementsByDate", "UniqueWebLogins", "UniqueAppLogins",
            "SamplesPerDate"
        ];

        this.alternatives = {

            "TimeToConversion":
                {
                    id: "TimeToConversion",
                    name: "Days To Conversion",
                    fetch: async () => getTimeToConversion(this.state.period)
                },
            "BuysByDate":
                {
                    id: "BuysByDate",
                    name: "Conversions per day",
                    fetch: async () => getBuysByDate(this.state.period)

                },
            "MeasurementsByDate":
                {
                    id: "MeasurementsByDate",
                    name: "Measurements per day",
                    fetch: async () => getMeasurementsByDate(this.state.period)

                },
            "UniqueWebLogins":
                {
                    id: "UniqueWebLogins",
                    name: "Unique Web Logins",
                    fetch: async () => getUniqueLoginStatistics(this.state.period, "Web",
                        this.state.exclude, this.state.company)
                },
            "UniqueAppLogins":
                {
                    id: "UniqueAppLogins",
                    name: "Unique App Logins",
                    fetch: async () => getUniqueLoginStatistics(this.state.period, "App",
                        this.state.exclude, this.state.company)
                },
            "SamplesPerDate":
                {
                    id: "SamplesPerDate",
                    name: "SamplesPerDate",
                    fetch: async () => getSampleStatistics(this.state.period,
                        this.state.exclude, this.state.company)
                }
        };

        this.getData();
    }

    setNextChart() {
        if (this.state.restrictions[this.state.alternative].charts.findIndex((c) => c === this.state.chartType) + 1 === this.state.restrictions[this.state.alternative].charts.length) {
            this.setState({chartType: this.state.restrictions[this.state.alternative].charts[0]})
        } else {
            console.log(this.state.restrictions[this.state.alternative].charts.findIndex((c) => c === this.state.chartType));
            console.log(this.state.restrictions[this.state.alternative].charts[this.state.restrictions[this.state.alternative].charts.find((c) => c === this.state.chartType) + 1]);

            this.setState({chartType: this.state.restrictions[this.state.alternative].charts[this.state.restrictions[this.state.alternative].charts.findIndex((c) => c === this.state.chartType) + 1]})
        }
    }

    static convertDataArrayToPercentage(data) {
        let sum = 0;
        for (let i = 0; i < data.length; i++) {
            sum += data[i].amount
        }
        for (let i = 0; i < data.length; i++) {
            data[i].amount = ((data[i].amount / sum) * 100).toFixed(2)
        }
        return data
    }

    async getData() {

        let alternative = this.state.alternative;
        console.log(alternative);
        console.log(this.state.restrictions[alternative]);

        let format = getFormatFunction(this.state.restrictions[alternative].format)
        console.log(format)

        if (this.state.representation === "discrete") {
            this.setState({data: format(await this.alternatives[alternative].fetch())})
        } else {
            this.setState({data: format(Statistics.convertDataArrayToPercentage(await this.alternatives[alternative].fetch()))})
        }

        this.setState({chartType: this.state.restrictions[alternative].charts[0]})
    }

    getSetOfAlternatives() {

        return (this.menus.map((alternative) =>
            this.buildMenuAlternative(this.alternatives[alternative].name, this.alternatives[alternative].id)
        ))

    }

    buildMenuAlternative(name, alternative) {

        return (
            <div style={{
                borderBottom: "1px solid #adadad",
                height: 45,
                width: "100%",
                color: this.state.alternative === alternative ? "white" : "#ADADAD",
                paddingTop: 18,
                cursor: "pointer"
            }}
                 onClick={() => {
                     this.setState({alternative: alternative});
                     this.getData(alternative)
                 }}>
                <span style={{marginLeft: 25}}>{name}</span>
            </div>
        )
    }

    render() {

        return (
            <div>
                 <div className="alternatives">
                      <div>
                        {this.getSetOfAlternatives()}
                    </div>
                </div>

                {this.getContent()}

            </div>
        )
    }

    getContent() {
        console.log(this.state.data)
        return (
            <div>
                <div style={{height: window.innerHeight - 240, marginLeft: 350, paddingTop: 70}}>
                    <Chart data={this.state.data} chart={this.state.chartType}/>
                </div>
                <div style={{
                    backgroundColor: "#212121", height: 45, width: window.innerWidth -1, left: 0, bottom: 0, position: "absolute",
                    borderRight: "1px solid grey", fontSize: 30
                }}>
						<span style={{float: "right", marginRight: 20, color: "#ADADAD", cursor: "pointer"}}
                              onClick={() => this.setNextChart()}
                        >{this.state.chartType}</span>

                    <span style={{
                        right: 100,
                        marginRight: 200,
                        color: "#ADADAD",
                        cursor: "pointer",
                        position: "absolute"
                    }}
                          onClick={async () => {
                              await this.setState({representation: this.state.representation === "discrete" ? "percent" : "discrete"})
                              await this.getData()
                          }}
                    >{this.state.representation}</span>

                    <span style={{
                        right: 100,
                        marginRight: 400,
                        color: "#ADADAD",
                        cursor: "pointer",
                        position: "absolute"
                    }}
                          onClick={async () => {
                              await this.setState(
                                  {exclude: this.state.exclude === "include" ? "exclude" : "include"})
                              await this.getData()
                          }}
                    >{this.state.exclude}</span>

                    {this.getOptions()}
                    {this.getInterval()}
                    {this.getPeriod()}
                    {this.getCompany()}
                    {this.getCohort()}
                </div>
            </div>
        )
    }

    getOptions() {
        if (!this.state.restrictions[this.state.alternative].subOptions) {
            return null
        }

        return (
            <span style={{left: 50, color: "#ADADAD", cursor: "pointer", marginTop: -3, position: "absolute"}}
                  onClick={() => {
                  }}>
				<span style={{fontSize: 18, color: "white"}}>Options: </span>
				<select style={{height: 30, borderRadious: 3}} onChange={async (event) => {
                    await this.setState({option: event.target.value})
                    await this.getData()
                }}>
					{this.createOptions()}
				</select>
			</span>
        )
    }

    createOptions() {
        return (this.state.restrictions[this.state.alternative].options.map((option) =>
            <option value={option}>{option}</option>
        ))
    }

    getPeriod() {
        if (!this.state.restrictions[this.state.alternative].period) {
            return null
        }

        return (
            <span style={{left: 300, color: "#ADADAD", cursor: "pointer", marginTop: -3, position: "absolute"}}
                  onClick={() => {
                  }}>
				<span style={{fontSize: 18, color: "white"}}>Time Period: </span>
				<select style={{height: 30, borderRadious: 3}} onChange={async (event) => {
                    await this.setState({period: event.target.value})
                    await this.getData()
                }}>
					<option value="week">Last Week</option>
					<option selected="selected" value="month">Last Month</option>
					<option value="quarter">Last Quarter</option>
					<option value="year">Last Year</option>
					<option value="all">Since Beginning</option>
				</select>
			</span>
        )
    }

    getCompany() {
        if (!this.state.restrictions[this.state.alternative].company) {
            return null
        }

        return (
            <span style={{left: 520, color: "#ADADAD", cursor: "pointer", marginTop: -3, position: "absolute"}}
                  onClick={() => {
                  }}>
				<span style={{fontSize: 18, color: "white"}}>Company: </span>
				<select style={{height: 30, borderRadious: 3}} onChange={async (event) => {
                    await this.setState({company: event.target.value})
                    await this.getData()
                }}>
					<option selected="selected" value="All">All</option>
					<option value="Arboreal">Arboreal</option>
					<option value="Sveaskog">Sveaskog</option>
					<option value="Holmen">Holmen</option>
                    <option value="SCA">SCA</option>
                    <option value="Martinsons">Martinsons</option>
                    <option value="Norra Skogsägarna">Norra Skogsägarna</option>
                    <option value="Södra Skogsägarna">Södra Skogsägarna</option>
                    <option value="Mellanskog">Mellanskog</option>
				</select>
			</span>
        )
    }

    getInterval() {

        if (!this.state.restrictions[this.state.alternative].interval) {
            return (null)
        }

        return (
            <span style={{left: 600, color: "#ADADAD", cursor: "pointer", marginTop: -3, position: "absolute"}}
                  onClick={() => {
                  }}>
				<span style={{fontSize: 18, color: "white"}}>Time Interval: </span>
				<select style={{height: 30, borderRadious: 3}} onChange={async (event) => {
                    await this.setState({interval: event.target.value})
                    this.getData(this.state.alternative)
                }}>
					<option value="day">Day</option>
					<option value="week">Week</option>
					<option value="month">Month</option>
					<option value="year">Year</option>
				</select>
			</span>
        )
    }

    getCohort() {

        if (!this.state.restrictions[this.state.alternative].cohort) {
            return (null)
        }

        return (
            <span style={{left: 900, color: "#ADADAD", cursor: "pointer", marginTop: -3, position: "absolute"}}
                  onClick={() => {
                  }}>
				<span style={{fontSize: 18, color: "white"}}>Cohort: </span>
				<select style={{height: 30, borderRadious: 3}} onChange={async (event) => {
                    await this.setState({cohort: event.target.value});
                    this.getData(this.state.alternative)
                }}>
					<option value="day">Day</option>
					<option value="week">Week</option>
					<option value="month">Month</option>
					<option value="year">Year</option>
				</select>
			</span>
        )
    }

}